import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { cloneDeep } from "lodash";
import ActionButtonLayout from "../layout/ActionButtonLayout";

import TkTotalAmountCalculationRefreshDialog from "../dialogTypes/TkTotalAmountCalculationRefreshDialog";

function TkTotalAmountCalculationRefreshButton(props) {

    const { t } = useTranslation();

    const { id, schema, grid, refresh, onSuccess, detailList, customizeErrorMsgCallback, ...others } = props;

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();
    const [modifySchema, setModifySchema] = useState();

    useEffect(() => {
        if (schema) {
            let newSchema = cloneDeep(schema)

            for (let column of newSchema.columns) {

                switch (column.name) {
                    case "camCost":
                        column.displayName = "CAMTIME"
                        column.hideInForm = false;
                        break;
                    default:
                        column.hideInForm = true;
                        break;
                }
            }

            setModifySchema(newSchema)
        }
    }, [schema])
    const onOpen = () => {

        if (grid) {

            setFormData({ ...(grid.selectedItems[0]) });

        }

        setOpen(true);

    };

    const onClose = () => {

        setOpen(false);

    };

    const onUpdateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

        refresh.refresh();

    };

    return (

        <>
            <ActionButtonLayout onClick={onOpen} {...others}>{t("buttonName.Refresh")}</ActionButtonLayout>
            <TkTotalAmountCalculationRefreshDialog
                id={id + "update-dialog"}
                mode="edit"
                formId={id + "update-form"}
                title={schema ? t(`dialog.title.${schema.name}.recalculation`) : ""}
                schema={modifySchema}
                initialData={formData}
                open={open}
                detailList={detailList}
                labels={[t("common.ok")]}
                onClose={onClose}
                onSuccess={onUpdateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </>

    );
}

export default TkTotalAmountCalculationRefreshButton;

